import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTenant } from '../../../contexts/TenantContext';
import useErrorHandler from '../../../hooks/useErrorHandler';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';
import { GUESTS_QUERY_KEY } from './useGetGuests';

// For a guest who asked by email to be left out of the marketing mail. Only the guest can consent again.
const useWithdrawGuestConsent = () => {
  const { tenantId } = useTenant();
  const queryClient = useQueryClient();
  const { handleError } = useErrorHandler();

  const mutation = useMutation({
    mutationFn: (userId) => apiClient.delete(`/v1/tenants/${tenantId}/guests/${userId}/marketing-consent`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: GUESTS_QUERY_KEY, exact: true }),
    onError: (error) => handleError(error, Routes.DASHBOARD_GUESTS),
  });

  const withdrawConsent = (userId, onSuccess) => mutation.mutate(userId, { onSuccess });

  return { withdrawConsent, isLoading: mutation.isPending };
};

export default useWithdrawGuestConsent;
